import React, { useState, useEffect } from 'react';
import { products } from '../../data';
import ProductCard from './ProductCard';
import { motion, AnimatePresence } from 'framer-motion';

const ProductSection = () => {
  const [filter, setFilter] = useState('all');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  const filteredProducts = filter === 'all' 
    ? products 
    : products.filter(p => p.category === filter);

  const categories = [
    { id: 'all', label: 'All Items' },
    { id: 'flights', label: 'Flavor Flights' },
    { id: 'gift-boxes', label: 'Gift Boxes' },
    { id: 'bundles', label: 'Party Bundles' },
  ];

  return (
    <section className="py-24 bg-frost-vanilla overflow-hidden" id="shop-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Explore the Cold-Chain Experience</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-lg mb-12">
            Select your batch from our curated collections. Each box is prepared to order and guaranteed to arrive frozen solid.
          </p>
          
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setFilter(cat.id)}
                className={`px-6 py-2.5 rounded-full font-bold text-sm transition-all duration-300 ${
                  filter === cat.id 
                    ? 'bg-frost-berry text-white shadow-lg' 
                    : 'bg-white text-gray-400 hover:text-frost-berry border border-frost-ice'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 min-h-[400px]">
          <AnimatePresence mode="wait">
            {isLoading ? (
              [...Array(4)].map((_, i) => (
                <div key={`skeleton-${i}`} className="bg-white rounded-[2.5rem] p-4 space-y-4 animate-pulse border border-frost-ice">
                  <div className="aspect-[4/5] bg-frost-ice rounded-[2rem]"></div>
                  <div className="h-6 bg-frost-ice rounded w-3/4"></div>
                  <div className="h-4 bg-frost-ice rounded w-1/2"></div>
                </div>
              ))
            ) : (
              filteredProducts.map(product => (
                <motion.div
                  key={product.id}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.3 }}
                >
                  <ProductCard product={product} />
                </motion.div>
              ))
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;